<template>
  <div
    ref="partialDiv"
    :class="{
      'container mx-auto mt-6': true,
    }"
  >
    <h2>
      {{ title }}
    </h2>
    <p
      :class="{
        'text-center text-xs leading-7 text-www-color-neutral-medium-dark md:text-15px': true,
      }"
    >
      {{ subtitle }}
    </p>

    <slot />
  </div>
</template>

<script lang="ts" setup>
import type { UssProPlan } from '~/sanity/types';

defineProps<UssProPlan>();
</script>

<style></style>
